/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../config/constants';


const ProductSKUDropdown = ({
    field: { name },
    form: { setFieldValue },
    getProductData,
    ...props
}) => {

    const [productData, setProductData] = useState([])
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        let token = localStorage.getItem('isloggedIn')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNumber')
        let data = JSON.stringify
            ({
                "customerNumber": customerNo,
                "userId": userId,
                "customer_no": customerNo,
                "user_id": userId,
                "customerNo": customerNo
            })

        Axios.get(`${APP_CONSTANTS.BASE_URL}masters/psLineItem?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': token
            }
        }).then((response => {
            setProductData(response.data.resultSet)
            getProductData(response.data.resultSet)
            setIsLoading(false)
        }))
            .catch(error => console.log(error))
        setIsLoading(false)
    }, [])


    let options = []
    if (productData && productData.length > 0) {
        productData.map((object, index) => {
            let temp = {}
            temp.key = object.psId
            temp.text = object.psDescription
            temp.value = object.psId
            return options[index] = temp
        })
    }

    const handleOnChange = (e, data) => {
        setFieldValue(name, data.value)
    }

    return (
        <Dropdown
            search
            selection
            onChange={(e, data) => handleOnChange(e, data)}
            options={options}
            loading={isLoading}
            {...props}
            fluid
        />
    )
}


export default ProductSKUDropdown